import { useRef, useCallback } from "react";

// pitch: 0-2 (lower = deeper), rate: 0.1-10 (lower = slower)
const PERSONA_PROFILES = {
  // US Presidents — ordered roughly oldest to newest
  "George Washington":       { pitch: 0.48, rate: 0.65 },
  "John Adams":              { pitch: 0.52, rate: 0.68 },
  "Thomas Jefferson":        { pitch: 0.58, rate: 0.72 },
  "James Madison":           { pitch: 0.54, rate: 0.70 },
  "James Monroe":            { pitch: 0.56, rate: 0.70 },
  "John Quincy Adams":       { pitch: 0.55, rate: 0.68 },
  "Andrew Jackson":          { pitch: 0.50, rate: 0.78 },
  "Martin Van Buren":        { pitch: 0.60, rate: 0.72 },
  "William Henry Harrison":  { pitch: 0.52, rate: 0.68 },
  "John Tyler":              { pitch: 0.57, rate: 0.70 },
  "James K. Polk":           { pitch: 0.59, rate: 0.73 },
  "Zachary Taylor":          { pitch: 0.53, rate: 0.72 },
  "Millard Fillmore":        { pitch: 0.60, rate: 0.72 },
  "Franklin Pierce":         { pitch: 0.62, rate: 0.75 },
  "James Buchanan":          { pitch: 0.55, rate: 0.68 },
  "Abraham Lincoln":         { pitch: 0.50, rate: 0.67 },
  "Andrew Johnson":          { pitch: 0.57, rate: 0.70 },
  "Ulysses S. Grant":        { pitch: 0.60, rate: 0.73 },
  "Rutherford B. Hayes":     { pitch: 0.62, rate: 0.73 },
  "James A. Garfield":       { pitch: 0.65, rate: 0.75 },
  "Chester A. Arthur":       { pitch: 0.63, rate: 0.75 },
  "Grover Cleveland":        { pitch: 0.58, rate: 0.73 },
  "Benjamin Harrison":       { pitch: 0.60, rate: 0.72 },
  "William McKinley":        { pitch: 0.62, rate: 0.74 },
  "Theodore Roosevelt":      { pitch: 0.72, rate: 1.05 },
  "William Howard Taft":     { pitch: 0.55, rate: 0.75 },
  "Woodrow Wilson":          { pitch: 0.63, rate: 0.78 },
  "Warren G. Harding":       { pitch: 0.60, rate: 0.80 },
  "Calvin Coolidge":         { pitch: 0.58, rate: 0.68 },
  "Herbert Hoover":          { pitch: 0.60, rate: 0.72 },
  "Franklin D. Roosevelt":   { pitch: 0.62, rate: 0.80 },
  "Harry S. Truman":         { pitch: 0.65, rate: 0.82 },
  "Dwight D. Eisenhower":    { pitch: 0.60, rate: 0.78 },
  "John F. Kennedy":         { pitch: 0.80, rate: 0.93 },
  "Lyndon B. Johnson":       { pitch: 0.58, rate: 0.83 },
  "Richard Nixon":           { pitch: 0.63, rate: 0.85 },
  "Gerald Ford":             { pitch: 0.65, rate: 0.80 },
  "Jimmy Carter":            { pitch: 0.67, rate: 0.82 },
  "Ronald Reagan":           { pitch: 0.70, rate: 0.85 },
  "George H. W. Bush":       { pitch: 0.65, rate: 0.82 },
  "Bill Clinton":            { pitch: 0.75, rate: 0.95 },
  "George W. Bush":          { pitch: 0.68, rate: 0.88 },
  "Barack Obama":            { pitch: 0.80, rate: 0.90 },
  "Donald Trump":            { pitch: 0.65, rate: 1.05 },
  "Joe Biden":               { pitch: 0.68, rate: 0.77 },

  // World leaders / famous figures
  "Alexander the Great":     { pitch: 0.72, rate: 0.88 },
  "Julius Caesar":           { pitch: 0.60, rate: 0.78 },
  "Cleopatra":               { pitch: 1.10, rate: 0.85 },
  "Napoleon Bonaparte":      { pitch: 0.68, rate: 0.90 },
  "Genghis Khan":            { pitch: 0.48, rate: 0.80 },
  "Attila the Hun":          { pitch: 0.50, rate: 0.82 },
  "Charlemagne":             { pitch: 0.55, rate: 0.72 },
  "King Henry VIII":         { pitch: 0.52, rate: 0.78 },
  "Oliver Cromwell":         { pitch: 0.57, rate: 0.75 },
  "Louis XIV":               { pitch: 0.60, rate: 0.73 },
  "Peter the Great":         { pitch: 0.53, rate: 0.78 },
  "Frederick the Great":     { pitch: 0.57, rate: 0.75 },
  "Catherine the Great":     { pitch: 1.00, rate: 0.80 },
  "Queen Elizabeth I":       { pitch: 1.00, rate: 0.73 },
  "Queen Elizabeth II":      { pitch: 1.05, rate: 0.80 },
  "Queen Victoria":          { pitch: 0.98, rate: 0.70 },
  "Akbar the Great":         { pitch: 0.60, rate: 0.78 },
  "Saladin":                 { pitch: 0.58, rate: 0.75 },
  "King George III":         { pitch: 0.60, rate: 0.73 },
  "Otto von Bismarck":       { pitch: 0.53, rate: 0.75 },
  "Simón Bolívar":           { pitch: 0.65, rate: 0.85 },
  "Sun Yat-sen":             { pitch: 0.67, rate: 0.80 },
  "Vladimir Lenin":          { pitch: 0.60, rate: 0.83 },
  "Leon Trotsky":            { pitch: 0.63, rate: 0.88 },
  "Charles de Gaulle":       { pitch: 0.55, rate: 0.73 },
  "Winston Churchill":       { pitch: 0.52, rate: 0.70 },
  "Benito Mussolini":        { pitch: 0.58, rate: 0.95 },
  "Francisco Franco":        { pitch: 0.57, rate: 0.78 },
  "Mahatma Gandhi":          { pitch: 0.68, rate: 0.75 },
  "Jawaharlal Nehru":        { pitch: 0.65, rate: 0.80 },
  "Indira Gandhi":           { pitch: 1.05, rate: 0.83 },
  "Atatürk":                 { pitch: 0.62, rate: 0.80 },
  "Deng Xiaoping":           { pitch: 0.60, rate: 0.78 },
  "Mikhail Gorbachev":       { pitch: 0.62, rate: 0.80 },
  "Boris Yeltsin":           { pitch: 0.58, rate: 0.82 },
  "Nelson Mandela":          { pitch: 0.63, rate: 0.78 },
  "Margaret Thatcher":       { pitch: 1.00, rate: 0.83 },
  "Tony Blair":              { pitch: 0.78, rate: 0.92 },
  "Angela Merkel":           { pitch: 1.05, rate: 0.85 },
  "Eleanor Roosevelt":       { pitch: 1.05, rate: 0.80 },
  "Amelia Earhart":          { pitch: 1.10, rate: 0.90 },
  "Harriet Tubman":          { pitch: 1.00, rate: 0.77 },
  "Frederick Douglass":      { pitch: 0.63, rate: 0.78 },
  "Rosa Parks":              { pitch: 1.05, rate: 0.82 },
  "Sojourner Truth":         { pitch: 0.97, rate: 0.75 },
  "Susan B. Anthony":        { pitch: 1.08, rate: 0.80 },
  "Martin Luther King Jr.":  { pitch: 0.65, rate: 0.82 },
  "Justin Trudeau":          { pitch: 0.78, rate: 0.95 },
  "Emmanuel Macron":         { pitch: 0.80, rate: 0.95 },
  "Xi Jinping":              { pitch: 0.60, rate: 0.80 },
  "Narendra Modi":           { pitch: 0.65, rate: 0.85 },
  "Recep Tayyip Erdoğan":    { pitch: 0.62, rate: 0.88 },
  "Jair Bolsonaro":          { pitch: 0.63, rate: 0.92 },
  "Lula da Silva":           { pitch: 0.67, rate: 0.88 },
  "Jacinda Ardern":          { pitch: 1.15, rate: 0.92 },
  "Scott Morrison":          { pitch: 0.72, rate: 0.90 },
  "Shinzo Abe":              { pitch: 0.68, rate: 0.82 },
  "Moon Jae-in":             { pitch: 0.70, rate: 0.83 },
  "Park Geun-hye":           { pitch: 1.10, rate: 0.85 },
  "Yoon Suk-yeol":           { pitch: 0.68, rate: 0.85 },
};

function nameHash(name) {
  let h = 0;
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) | 0;
  return Math.abs(h);
}

function hashProfile(name) {
  const h = nameHash(name);
  const pitches = [0.55, 0.60, 0.65, 0.70, 0.75, 0.80];
  const rates   = [0.68, 0.72, 0.78, 0.82, 0.88, 0.92];
  return {
    pitch: pitches[h % pitches.length],
    rate:  rates[Math.floor(h / pitches.length) % rates.length],
  };
}

export function useOldManVoice() {
  const voiceCache = useRef({});

  const speak = useCallback((text, personaName = "") => {
    if (!window.speechSynthesis) return;
    window.speechSynthesis.cancel();

    const utterance = new SpeechSynthesisUtterance(text);
    const profile = PERSONA_PROFILES[personaName] || hashProfile(personaName);

    utterance.pitch  = profile.pitch;
    utterance.rate   = profile.rate;
    utterance.volume = 1;

    const voices = window.speechSynthesis.getVoices();
    if (voices.length > 0) {
      if (voiceCache.current[personaName] === undefined) {
        voiceCache.current[personaName] = nameHash(personaName || "default") % voices.length;
      }
      utterance.voice = voices[voiceCache.current[personaName] % voices.length];
    }

    window.speechSynthesis.speak(utterance);
  }, []);

  const stop = useCallback(() => {
    if (window.speechSynthesis) window.speechSynthesis.cancel();
  }, []);

  return { speak, stop };
}
